<div style="margin-top: 3px; margin-left: 3px;">
  <i id="patientInfo" class="dx-icon-info" (mouseenter)="togglePatientInfo()"
     (mouseleave)="togglePatientInfo()"
     *ngIf="selectedPatient !== undefined && selectedPatient !== null"
     style="font-size: 20px !important;"></i>
</div>

<dx-popover
    target="#patientInfo"
position="bottom"
[closeOnOutsideClick]="true"
[width]="300"
[visible]="patientInfoVisible"
>
<div *dxTemplate="let data = model; of: 'content'">
  <address>
    <strong>Patient Id</strong>
    {{ PatientCode }} <br/>
    <strong>Address</strong>
    {{ PatientAddress }}<br/>
    <strong>Birthdate</strong>
    {{ PatientBirthDate }} <br/>
    <strong>Gender</strong>
    {{ PatientGender }} <br/>
    <strong>SSN</strong>
    {{ PatientSSN }} <br/>
    <strong>Primary Physician</strong>
    {{ PatientPrimaryPhysician }} <br/>
  </address>
</div>
</dx-popover>
